import React from "react";
import { JSONRenderer } from "../JSONRenderer/JSONRenderer";
import { parseNestedJSON } from "../../../../../../helpers/json-helpers";
import { SummaryResponseDisplay } from "./SummaryResponseDisplay/SummaryResponseDisplay";
import { IndicesResponseDisplay } from "./IndicesResponseDisplay/IndicesResponseDisplay";
import { AnswerResponseDisplay } from "./AnswerResponseDisplay/AnswerResponseDisplay";

export const ResponseDisplay = ({ response, t }) => {
  if (!response) return <div>{t("common.notAvailable")}</div>;

  const parsedResponse = parseNestedJSON(response);

  if (!parsedResponse) return <div>{response}</div>;

  // For summary response (language, summary, currentQuestion)
  if (parsedResponse.language && parsedResponse.summary) {
    return <SummaryResponseDisplay data={parsedResponse} t={t} />;
  }

  // For section indices response (array of indices)
  if (
    Array.isArray(parsedResponse) ||
    (typeof parsedResponse === "string" && parsedResponse.match(/^\{.*\}$/))
  ) {
    return <IndicesResponseDisplay data={parsedResponse} t={t} />;
  }

  // For answer response (answer, sources)
  if (parsedResponse.answer) {
    return <AnswerResponseDisplay data={parsedResponse} t={t} />;
  }

  // Fallback for other formats
  return <JSONRenderer data={parsedResponse} />;
};
